import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import AdminLayout from '../../components/admin/AdminLayout'
import { useAuth } from '../../context/AuthContext'
import { API_BASE } from '../../utils/api'

interface SubType {
    _id: string;
    name: string;
    parent?: any;
}

export default function AdminPropertySubtypes() {
    const navigate = useNavigate()
    const location = useLocation()
    const { token } = useAuth()
    const [items, setItems] = useState<SubType[]>([])
    const [types, setTypes] = useState<any[]>([])
    const [loading, setLoading] = useState(true)

    const fetchData = async () => {
        setLoading(true)
        try {
            const [subRes, typeRes] = await Promise.all([
                fetch(`${API_BASE}/property-subtypes`),
                fetch(`${API_BASE}/property-types`)
            ])
            const subData = await subRes.json()
            const typeData = await typeRes.json()
            if (Array.isArray(subData)) setItems(subData)
            if (Array.isArray(typeData)) setTypes(typeData)
        } catch (err) { console.error(err) } finally { setLoading(false) }
    }

    useEffect(() => { fetchData() }, [])

    const parentFilter = React.useMemo(() => {
        const q = new URLSearchParams(location.search).get('parent')
        return q || null
    }, [location.search])

    const handleDelete = async (id: string) => {
        if (!window.confirm('Delete this subtype?')) return
        try {
            await fetch(`${API_BASE}/property-subtypes/${id}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } })
            fetchData()
        } catch (err) { console.error(err) }
    }

    return (
        <AdminLayout>
            <div className="flex items-center justify-between mb-8">
                <div>
                     <h1 className="text-3xl font-bold text-[#05144b] mb-2 leading-none">Property Sub-Classifications</h1>
                    <p className="text-[#05144b] font-semibold text-[14px]">Manage secondary property categorizations and relationship mapping.</p>
                </div>
                <div>
                    <button className="px-6 py-3 bg-white border-2 border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded-md font-bold transition-all shadow-md active:scale-95" onClick={() => navigate('/admin-add-property-subtype')}>
                        <i className="fa-solid fa-plus-circle me-2"></i> Add Subtype
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-md border p-4">
                {loading ? <div className="py-20 text-center">Loading...</div> : (
                    <table className="w-full">
                        <thead>
                            <tr>
                                 <th className="text-left p-4 font-bold text-[#05144b]">Sub-Category</th>
                                <th className="text-left p-4 font-bold text-[#05144b]">Parent Anchor</th>
                                <th className="text-right p-4 font-bold text-[#05144b]">Operational Hub</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(parentFilter ? items.filter(i => {
                                const pid = i.parent && (i.parent._id || i.parent)
                                return pid === parentFilter
                            }) : items).map(i => (
                                <tr key={i._id} className="border-t">
                                     <td className="p-4 font-bold text-[#05144b]">{i.name}</td>
                                    <td className="p-4 text-[#05144b]/60 font-semibold">{i.parent?.name || '—'}</td>
                                    <td className="p-3 text-right">
                                        <button className="px-3 py-1 bg-white border border-[#05144b] text-[#05144b] hover:bg-blue-50 rounded mr-2 transition-all shadow-sm active:scale-95">Edit</button>
                                         <button className="px-3 py-1 bg-white border-2 border-slate-50 text-rose-600 hover:bg-rose-600 hover:text-white rounded transition-all shadow-sm active:scale-95" onClick={() => handleDelete(i._id)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </AdminLayout>
    )
}
